export default function()
{    
    return {
        'preload': function()
        {
            // Set up the queues
            let queue = new createjs.LoadQueue();

            queue.setMaxConnections(3);
            queue.installPlugin(createjs.Sound);

            return new Promise(
                function (resolve, reject) {            
                    queue.addEventListener('progress', function(ev)
                    {
                       //notify(ev);
                    });
                    queue.addEventListener('complete', function()
                    {
                        console.log('preload completed');
                        resolve(true);
                    });

                    queue.loadManifest('audio/manifest.json');
                    //queue.loadManifest('images/manifest.json');
                });
        }
    };
}